import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class ResourcesService {
  fetchResources = params => {
    // optional bucketName param
    return fetch(config.config.endpointUrls.fetchResources(params), {
      method: 'GET'
    })
  }
  fetchResource = (params) => {
    return fetch(config.config.endpointUrls.fetchResource(params), {
      method: 'GET'
    })
  }
}

export default new ResourcesService()



// WEBPACK FOOTER //
// ../src/services/resourcesService/resourcesService.js